import { isTouchEvent } from '../gestures/utils/event-type.mjs';
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */

function filterPrimaryPointer(eventHandler) {
  return function (event) {
    var isMouseEvent = event instanceof MouseEvent;
    var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;

    if (isPrimaryPointer) {
      eventHandler(event);
    }
  };
}

var defaultPagePoint = {
  pageX: 0,
  pageY: 0
};

function pointFromTouch(e) {
  var pointType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page";
  var primaryTouch = e.touches[0] || e.changedTouches[0];
  var point = primaryTouch || defaultPagePoint;
  return {
    x: point[pointType + "X"],
    y: point[pointType + "Y"]
  };
}

function pointFromMouse(point) {
  var pointType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page";
  return {
    x: point[pointType + "X"],
    y: point[pointType + "Y"]
  };
}

function extractEventInfo(event) {
  var pointType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "page";
  return {
    point: isTouchEvent(event) ? pointFromTouch(event, pointType) : pointFromMouse(event, pointType)
  };
}

var wrapHandler = function wrapHandler(handler) {
  var shouldFilterPrimaryPointer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var listener = function listener(event) {
    return handler(event, extractEventInfo(event));
  };

  return shouldFilterPrimaryPointer ? filterPrimaryPointer(listener) : listener;
};

export { extractEventInfo, wrapHandler };